import axios from "axios"

const actionGetAnimalsReleased = async ({commit}, payload) => {
  const animalsReleased = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/released`, {headers:{...payload.headers}, params:{...payload.params}});
  commit('SET_ANIMALS', animalsReleased.data.data);
  return animalsReleased.data;
}

const actionGetRegimes = async ({commit}) => {
  const regimes = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/get_regimes`);
  commit("SET_REGIMES", regimes.data.regimes);
  commit("SET_EXPLANATIONS", regimes.data.explanations);

}

const actionGetAllAnimals = async ({commit}, payload) => {
  const allAnimals = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals`, {headers:{farm:payload}});
  commit("SET_ALL_ANIMALS", allAnimals.data);
  return allAnimals.data;
}

// eslint-disable-next-line no-empty-pattern
const actionKillAnimal = async ({}, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/animals/${payload.animal_id}/inactive`, {kind:payload.kind, event_at:payload.event_at});
}

// eslint-disable-next-line no-empty-pattern
const actionGetLastUsedAnimals = async ({}, payload) => {
  const lastUsed = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/lasted`, {headers:{farm:payload.farm}, params:{service_date:payload.service_date}});
  return lastUsed.data;
}

const actionGetAnimalsHeadquarters = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload
    }
  }
  const headquarters = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/matrizes`, config);
  commit("SET_HEADQUARTERS", headquarters.data);
}

const actionSaveAnimalBirth = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload.farm_id
    }
  }
  delete payload.farm_id
  const animalBirth = await axios.post(`${process.env.VUE_APP_URL_API}/v1/animal_births`,{animal_birth:payload}, config);
  commit("SET_NEW_BIRTH", animalBirth.data);
}

const actionSaveNewAnimal = async (_, payload) => {
  const config = {
    headers:{
      farm:payload.animal.farm_id
    }
  }
  const animalPaylod = {...payload};
  delete animalPaylod.animal.farm_id;
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/animals`,animalPaylod, config);
}

const actionGetAnimalsBirth = async ({commit}, payload) => {
  const animals_birth = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animal_births`, {params:{...payload}});
  commit("SET_ANIMALS_BIRTH", animals_birth.data.animals);
  commit("SET_BIRTH_PAGINATION", animals_birth.data.options.meta);
}

const actionGetAnimalsCurrentBirth = async (_, payload) => {
  const animals_birth = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animal_births`, {params:payload});
  return animals_birth.data.animals;
}

const actionEditAnimalBirth = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload.farm_id
    }
  };
  delete payload.farm_id;
  const animalBirth = await axios.put(`${process.env.VUE_APP_URL_API}/v1/animal_births/${payload.id}`,{
    animal_birth:payload
  }, config);
  commit("SET_NEW_EDIT", animalBirth.data);
}

const actionGetAnimalsReasons = async ({commit}) => {
  const reasons = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/get_reasons`);
  commit("SET_DOWNS_REASON", reasons.data.downs);
  commit("SET_CLOSURE", reasons.data.end_production_reasons);
}

const actionSearchAllAnimalsBirth = async ({commit}, payload) => {
  const result = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/general`, {params:payload});
  commit("SET_HEADQUARTERS", result.data);
}

const actionSearchAnimalsGeneral = async (_, payload) => {
  const result = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/general`, {params:payload});
  return result.data;
}

const actionEditAnimal = async (_, payload) => {
  const config = {
    headers:{
      farm:payload.animal.farm_id
    }
  }
  const animalPaylod = {...payload};
  delete animalPaylod.animal.farm_id;
  await axios.put(`${process.env.VUE_APP_URL_API}/v1/animals/${animalPaylod.animal.id}`, animalPaylod, config);
}

const actionGetAvailableOrders = async (_, payload) => {
  const result = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/${payload.animal}/free_orders`, {params:{birthday:payload.date}});
  return result.data.orders;
}

const actionSaveKill = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/animals/${payload.animal_id}/inactive`, {kind:payload.kind, event_at:payload.event_at});
}

const actionGetBirthProductionInfo = async ({commit}, payload) => {
  
  const birth_production_info = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/${payload.animal_id}/animal_history`);
  commit("SET_BIRTH_PRODUCTION_INFO", birth_production_info.data);
}

const actionGetAnimalsKills = async ({commit}, payload) => {
  const animalsKilled = await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/animals_down`, {params:payload});
  commit("SET_ANIMALS_KILLED", animalsKilled.data);
  commit("SET_KILLS_PAGINATION", animalsKilled.data?.options?.meta)
}

export default {
  actionGetAnimalsReleased,
  actionGetAllAnimals,
  actionKillAnimal,
  actionGetLastUsedAnimals,
  actionGetAnimalsHeadquarters,
  actionSaveAnimalBirth,
  actionGetAnimalsBirth,
  actionEditAnimalBirth,
  actionGetRegimes,
  actionGetAnimalsReasons,
  actionSearchAllAnimalsBirth,
  actionSearchAnimalsGeneral,
  actionEditAnimal,
  actionGetAnimalsCurrentBirth,
  actionGetAvailableOrders,
  actionSaveKill,
  actionGetBirthProductionInfo,
  actionGetAnimalsKills,
  actionSaveNewAnimal
}